import type { Company } from '../../Companies/Types/companyTypes';

export interface ExpenseInvoiceCompanyLookup {
  id: number;
  name: string;
}

export const mapCompanyToExpenseInvoiceLookup = (
  company: Company | undefined | null
): ExpenseInvoiceCompanyLookup | undefined => {
  if (!company) {
    return undefined;
  }

  return {
    id: company.id,
    name: company.name,
  };
};
